/* ========================================================================
   Sliders
 ========================================================================== */

app.sliders = (function () {
  'use strict';

  function initPrevNextButtons(prevBtn, nextBtn, embla) {
    prevBtn.addEventListener('click', embla.scrollPrev, false);
    nextBtn.addEventListener('click', embla.scrollNext, false);
  }

  function disablePrevNextButtons(prevBtn, nextBtn, embla) {
    if (embla.canScrollPrev()) {
      prevBtn.removeAttribute('disabled');
    } else {
      prevBtn.setAttribute('disabled', 'disabled');
    }

    if (embla.canScrollNext()) {
      nextBtn.removeAttribute('disabled');
    } else {
      nextBtn.setAttribute('disabled', 'disabled');
    }
  }

  function initDots(dotsArray, embla) {
    dotsArray.forEach((dotNode, i) => {
      dotNode.classList.add('embla__dot');
      dotNode.addEventListener(
        'click',
        () => {
          embla.scrollTo(i);
        },
        false
      );
    });
  }

  function generateDots(dots, embla) {
    const scrollSnaps = embla.scrollSnapList();
    const dotsFrag = document.createDocumentFragment();
    const dotsArray = scrollSnaps.map(() => {
      document.createElement('button');
    });

    dotsArray.forEach((dotNode) => {
      dotsFrag.appendChild(dotNode);
    });

    dots.appendChild(dotsFrag);
    return dotsArray;
  }

  function selectDot(dotsArray, embla) {
    const previous = embla.previousScrollSnap();
    const selected = embla.selectedScrollSnap();

    dotsArray[previous].classList.remove('is-selected');
    dotsArray[selected].classList.add('is-selected');
  }

  // Expose public functions and variables
  return {
    initPrevNextButtons: initPrevNextButtons,
    disablePrevNextButtons: disablePrevNextButtons,
    initDots: initDots,
    generateDots: generateDots,
    selectDot: selectDot,
  };
})();
